export default __webpack_public_path__ + "static/media/warehouse.fba3ab32.svg";